import { render, staticRenderFns } from "./AutomationPreview.vue?vue&type=template&id=70dc9bd8"
import script from "./AutomationPreview.vue?vue&type=script&lang=js"
export * from "./AutomationPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports